import { sortBy, filter } from 'lodash';
export default ({ defaultIsSupervisor, stepProjects }) => [
    {
        label: 'Name',
        key: 'name',
        type: 'string',
        elementProps: {
            isRequired: true,
            placeholder: 'Widget group name',
        },
    },
    {
        label: 'Asset type',
        key: 'assetType',
        type: 'select',
        elementProps: (data, setData) => ({
            onChange: (option) => {
                setData(Object.assign(Object.assign({}, data), { assetType: option.value, steps: [] }));
            },
            options: [
                { label: 'Shots', value: 'sh' },
                { label: 'Models', value: 'mo' },
            ],
            style: { width: '100%' },
            placeholder: 'Select an asset type',
        }),
    },
    {
        label: 'Steps',
        key: 'steps',
        type: 'muiautocomplete',
        elementProps: (data) => {
            return {
                options: sortBy(filter(stepProjects, (step) => step.assetType === data.assetType), ['name']).map((step) => ({
                    label: step.name,
                    value: step.id,
                })),
                multiple: true,
                disabled: !data.assetType,
                style: { width: '100%' },
            };
        },
    },
    {
        label: 'Limited access group',
        key: 'isSupervisor',
        type: 'checkbox',
        elementProps: {
            disabled: defaultIsSupervisor,
        },
    },
];
